import { normalize, schema } from 'normalizr';
import { SessionViewModel } from 'stageclip-common';

import * as SessionHelper from '../../helpers/sessionHelper';
import { SessionInfo } from '../../models/sessionInfo';
import { ById } from '../../store/normalizedState';

import * as EntityNormalizers from './entityNormalizers';
import * as UserNormalizers from './userNormalizers';

const { Entity } = schema;

export interface NormalizesSessions extends UserNormalizers.NormalizedUsers {
  sessions: ById<SessionInfo>;
}

export const sessionSchema = new Entity('sessions', {
  user: UserNormalizers.userSchema,
});

export function normalizeSession(data: SessionViewModel): EntityNormalizers.NormalizedEntityArray<NormalizesSessions> {
  SessionHelper.storeSession(data);

  return normalize(data, sessionSchema);
}
